const INTERNAL_DOMAINS = ['forjahub.com'];

export function isInternalUrl(url: string): boolean {
  if (url.startsWith('/')) return true;
  try {
    const parsed = new URL(url);
    if (parsed.hostname === 'localhost') return true;
    return INTERNAL_DOMAINS.some(d => parsed.hostname === d || parsed.hostname.endsWith('.' + d));
  } catch { return false; }
}

export function getInternalPath(url: string): string {
  if (url.startsWith('/')) return url;
  const parsed = new URL(url);
  return parsed.pathname + parsed.search + parsed.hash;
}
